module.exports = "<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\">\n  {{alert.message}}\n  <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/alert.component.html
// module id = ./src/app/alert/alert.component.html
// module chunks = main